import { FaYoutube } from 'react-icons/fa';
import { CheckCircle } from 'lucide-react';
import { PreviewCardShell } from './PreviewCardShell';

interface YouTubeChannelMockupProps {
  channelName?: string;
  handle?: string;
  subscribers?: string;
  videos?: string;
  description: string;
  verified?: boolean;
  previewLabel?: string;
}

export const YouTubeChannelMockup = ({
  channelName = 'Channel Name',
  handle = '@handle',
  subscribers = '0',
  videos = '0',
  description,
  verified = false,
  previewLabel = 'YouTube Channel Preview',
}: YouTubeChannelMockupProps) => {
  return (
    <PreviewCardShell
      className="mb-3"
      bodyClassName="p-4"
      badgeClassName="bg-[#FF0000]"
      badge={<FaYoutube className="h-5 w-5 text-white" />}
      label={previewLabel}
    >
        <div className="flex gap-4 mb-4">
          {/* Channel picture */}
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-red-400 to-red-600 flex-shrink-0" />

          <div className="flex-1">
            {/* Channel name */}
            <div className="flex items-center gap-1.5 mb-1">
              <h3 className="text-lg font-semibold text-zinc-50">{channelName}</h3>
              {verified && <CheckCircle className="h-5 w-5 text-zinc-300" fill="currentColor" />}
            </div>

            {/* Handle and stats */}
            <div className="mb-2 text-xs text-zinc-400">
              {handle} · {subscribers} subscribers · {videos} videos
            </div>

            {/* Description preview */}
            <p className="mb-3 line-clamp-2 text-sm text-zinc-200">{description}</p>

            {/* Subscribe button */}
            <button className="bg-black dark:bg-white text-white dark:text-black text-sm font-semibold py-2 px-6 rounded-full opacity-60 cursor-not-allowed">
              Subscribe
            </button>
          </div>
        </div>
    </PreviewCardShell>
  );
};
